// extracted by mini-css-extract-plugin
export default {"chatList":"styles_chatList__RXDL0","spinner":"styles_spinner__emvVR"};